export const availableCountries = [
    { CODE : 'AF', LIB : 'Afghanistan',  INDICATIF : '+93' },
    { CODE : 'AL', LIB : 'Albanie',  INDICATIF : '+355' },
    { CODE : 'DZ', LIB : 'Algérie',  INDICATIF : '+213' },
    { CODE : 'AD', LIB : 'Andorre',  INDICATIF : '+376' },
    { CODE : 'AO', LIB : 'Angola',  INDICATIF : '+244' },
    { CODE : 'AG', LIB : 'Antigua-et-Barbuda (-268)',  INDICATIF : '+1' },
    { CODE : 'AR', LIB : 'Argentine',  INDICATIF : '+54' },
    { CODE : 'AM', LIB : 'Arménie',  INDICATIF : '+374' },
    { CODE : 'AU', LIB : 'Australie',  INDICATIF : '+61' },
    { CODE : 'AT', LIB : 'Autriche',  INDICATIF : '+43' },
    { CODE : 'AZ', LIB : 'Azerbaïdjan',  INDICATIF : '+994' },
    { CODE : 'BS', LIB : 'Bahamas',  INDICATIF : '+1-242' },
    { CODE : 'BH', LIB : 'Bahreïn',  INDICATIF : '+973' },
    { CODE : 'BD', LIB : 'Bangladesh',  INDICATIF : '+880' },
    { CODE : 'BB', LIB : 'Barbade',  INDICATIF : '+1-246' },
    { CODE : 'BY', LIB : 'Biélorussie',  INDICATIF : '+375' },
    { CODE : 'BE', LIB : 'Belgique',  INDICATIF : '+32' },
    { CODE : 'BZ', LIB : 'Belize',  INDICATIF : '+501' },
    { CODE : 'BJ', LIB : 'Bénin',  INDICATIF : '+229' },
    { CODE : 'BT', LIB : 'Bhoutan',  INDICATIF : '+975' },
    { CODE : 'BO', LIB : 'Bolivie (État plurinational de)',  INDICATIF : '+591' },
    { CODE : 'BA', LIB : 'Bosnie-Herzégovine',  INDICATIF : '+387' },
    { CODE : 'BW', LIB : 'Botswana',  INDICATIF : '+267' },
    { CODE : 'BR', LIB : 'Brésil',  INDICATIF : '+55' },
    { CODE : 'BN', LIB : 'Brunéi Darussalam',  INDICATIF : '+673' },
    { CODE : 'BG', LIB : 'Bulgarie',  INDICATIF : '+359' },
    { CODE : 'BF', LIB : 'Burkina Faso',  INDICATIF : '+226' },
    { CODE : 'BI', LIB : 'Burundi',  INDICATIF : '+257' },
    { CODE : 'CV', LIB : 'Cabo Verde',  INDICATIF : '+238' },
    { CODE : 'KH', LIB : 'Cambodge',  INDICATIF : '+855' },
    { CODE : 'CM', LIB : 'Cameroun',  INDICATIF : '+237' },
    { CODE : 'CA', LIB : 'Canada',  INDICATIF : '+1' },
    { CODE : 'CF', LIB : 'République centrafricaine',  INDICATIF : '+236' },
    { CODE : 'TD', LIB : 'Tchad',  INDICATIF : '+235' },
    { CODE : 'CL', LIB : 'Chili',  INDICATIF : '+56' },
    { CODE : 'CN', LIB : 'Chine',  INDICATIF : '+86' },
    { CODE : 'CO', LIB : 'Colombie',  INDICATIF : '+57' },
    { CODE : 'KM', LIB : 'Comores',  INDICATIF : '+269' },
    { CODE : 'CG', LIB : 'Congo',  INDICATIF : '+242' },
    { CODE : 'CR', LIB : 'Costa Rica',  INDICATIF : '+506' },
    { CODE : 'HR', LIB : 'Croatie',  INDICATIF : '+385' },
    { CODE : 'CU', LIB : 'Cuba',  INDICATIF : '+53' },
    { CODE : 'CY', LIB : 'Chypre',  INDICATIF : '+357' },
    { CODE : 'CZ', LIB : 'Tchéquie',  INDICATIF : '+420' },
    { CODE : 'CI', LIB : 'Côte d\'Ivoire',  INDICATIF : '+225' },
    { CODE : 'KP', LIB : 'République populaire démocratique de Corée',  INDICATIF : '+850' },
    { CODE : 'CD', LIB : 'République démocratique du Congo',  INDICATIF : '+243' },
    { CODE : 'DK', LIB : 'Danemark',  INDICATIF : '+45' },
    { CODE : 'DJ', LIB : 'Djibouti',  INDICATIF : '+253' },
    { CODE : 'DM', LIB : 'Dominique',  INDICATIF : '+1-767' },
    { CODE : 'DO', LIB : 'République dominicaine',  INDICATIF : '+1-809, +1-829, +1-849' },
    { CODE : 'EC', LIB : 'Équateur',  INDICATIF : '+593' },
    { CODE : 'EG', LIB : 'Égypte',  INDICATIF : '+20' },
    { CODE : 'SV', LIB : 'Salvador',  INDICATIF : '+503' },
    { CODE : 'GQ', LIB : 'Guinée équatoriale',  INDICATIF : '+240' },
    { CODE : 'ER', LIB : 'Érythrée',  INDICATIF : '+291' },
    { CODE : 'EE', LIB : 'Estonie',  INDICATIF : '+372' },
    { CODE : 'ET', LIB : 'Éthiopie',  INDICATIF : '+251' },
    { CODE : 'FJ', LIB : 'Fidji',  INDICATIF : '+679' },
    { CODE : 'FI', LIB : 'Finlande',  INDICATIF : '+358' },
    { CODE : 'FR', LIB : 'France',  INDICATIF : '+33' },
    { CODE : 'GA', LIB : 'Gabon',  INDICATIF : '+241' },
    { CODE : 'GM', LIB : 'Gambie',  INDICATIF : '+220' },
    { CODE : 'GE', LIB : 'Géorgie',  INDICATIF : '+995' },
    { CODE : 'DE', LIB : 'Allemagne',  INDICATIF : '+49' },
    { CODE : 'GH', LIB : 'Ghana',  INDICATIF : '+233' },
    { CODE : 'GR', LIB : 'Grèce',  INDICATIF : '+30' },
    { CODE : 'GD', LIB : 'Grenade',  INDICATIF : '+1-473' },
    { CODE : 'GT', LIB : 'Guatemala',  INDICATIF : '+502' },
    { CODE : 'GN', LIB : 'Guinée',  INDICATIF : '+224' },
    { CODE : 'GW', LIB : 'Guinée-Bissau',  INDICATIF : '+245' },
    { CODE : 'GY', LIB : 'Guyana',  INDICATIF : '+592' },
    { CODE : 'HT', LIB : 'Haïti',  INDICATIF : '+509' },
    { CODE : 'HN', LIB : 'Honduras',  INDICATIF : '+504' },
    { CODE : 'HU', LIB : 'Hongrie',  INDICATIF : '+36' },
    { CODE : 'IS', LIB : 'Islande',  INDICATIF : '+354' },
    { CODE : 'IN', LIB : 'Inde',  INDICATIF : '+91' },
    { CODE : 'ID', LIB : 'Indonésie',  INDICATIF : '+62' },
    { CODE : 'IR', LIB : 'Iran (République islamique)',  INDICATIF : '+98' },
    { CODE : 'IQ', LIB : 'Iraq',  INDICATIF : '+964' },
    { CODE : 'IE', LIB : 'Irlande',  INDICATIF : '+353' },
    { CODE : 'IL', LIB : 'Israël',  INDICATIF : '+972' },
    { CODE : 'IT', LIB : 'Italie',  INDICATIF : '+39' },
    { CODE : 'JM', LIB : 'Jamaïque',  INDICATIF : '+1-876' },
    { CODE : 'JP', LIB : 'Japon',  INDICATIF : '+81' },
    { CODE : 'JO', LIB : 'Jordanie',  INDICATIF : '+962' },
    { CODE : 'KZ', LIB : 'Kazakhstan',  INDICATIF : '+7' },
    { CODE : 'KE', LIB : 'Kenya',  INDICATIF : '+254' },
    { CODE : 'KI', LIB : 'Kiribati',  INDICATIF : '+686' },
    { CODE : 'KW', LIB : 'Koweït',  INDICATIF : '+965' },
    { CODE : 'KG', LIB : 'Kirghizistan',  INDICATIF : '+996' },
    { CODE : 'LA', LIB : 'République démocratique populaire lao',  INDICATIF : '+856' },
    { CODE : 'LV', LIB : 'Lettonie',  INDICATIF : '+371' },
    { CODE : 'LB', LIB : 'Liban',  INDICATIF : '+961' },
    { CODE : 'LS', LIB : 'Lesotho',  INDICATIF : '+266' },
    { CODE : 'LR', LIB : 'Libéria',  INDICATIF : '+231' },
    { CODE : 'LY', LIB : 'Libye',  INDICATIF : '+218' },
    { CODE : 'LI', LIB : 'Liechtenstein',  INDICATIF : '+423' },
    { CODE : 'LT', LIB : 'Lituanie',  INDICATIF : '+370' },
    { CODE : 'LU', LIB : 'Luxembourg',  INDICATIF : '+352' },
    { CODE : 'MG', LIB : 'Madagascar',  INDICATIF : '+261' },
    { CODE : 'MW', LIB : 'Malawi',  INDICATIF : '+265' },
    { CODE : 'MY', LIB : 'Malaisie',  INDICATIF : '+60' },
    { CODE : 'MV', LIB : 'Maldives',  INDICATIF : '+960' },
    { CODE : 'ML', LIB : 'Mali',  INDICATIF : '+223' },
    { CODE : 'MT', LIB : 'Malte',  INDICATIF : '+356' },
    { CODE : 'MH', LIB : 'Îles Marshall',  INDICATIF : '+692' },
    { CODE : 'MR', LIB : 'Mauritanie',  INDICATIF : '+222' },
    { CODE : 'MU', LIB : 'Maurice',  INDICATIF : '+230' },
    { CODE : 'MX', LIB : 'Mexique',  INDICATIF : '+52' },
    { CODE : 'FM', LIB : 'Micronésie (États fédérés de)',  INDICATIF : '+691' },
    { CODE : 'MC', LIB : 'Monaco',  INDICATIF : '+377' },
    { CODE : 'MN', LIB : 'Mongolie',  INDICATIF : '+976' },
    { CODE : 'ME', LIB : 'Monténégro',  INDICATIF : '+382' },
    { CODE : 'MA', LIB : 'Maroc',  INDICATIF : '+212' },
    { CODE : 'MZ', LIB : 'Mozambique',  INDICATIF : '+258' },
    { CODE : 'MM', LIB : 'Myanmar',  INDICATIF : '+95' },
    { CODE : 'NA', LIB : 'Namibie',  INDICATIF : '+264' },
    { CODE : 'NR', LIB : 'Nauru',  INDICATIF : '+674' },
    { CODE : 'NP', LIB : 'Népal',  INDICATIF : '+977' },
    { CODE : 'NL', LIB : 'Pays-Bas',  INDICATIF : '+31' },
    { CODE : 'NZ', LIB : 'Nouvelle-Zélande',  INDICATIF : '+64' },
    { CODE : 'NI', LIB : 'Nicaragua',  INDICATIF : '+505' },
    { CODE : 'NE', LIB : 'Niger',  INDICATIF : '+227' },
    { CODE : 'NG', LIB : 'Nigéria',  INDICATIF : '+234' },
    { CODE : 'NO', LIB : 'Norvège',  INDICATIF : '+47' },
    { CODE : 'NC', LIB : 'Nouvelle Calédonie',  INDICATIF : '+687' },
    { CODE : 'OM', LIB : 'Oman',  INDICATIF : '+968' },
    { CODE : 'PK', LIB : 'Pakistan',  INDICATIF : '+92' },
    { CODE : 'PW', LIB : 'Palaos',  INDICATIF : '+680' },
    { CODE : 'PA', LIB : 'Panama',  INDICATIF : '+507' },
    { CODE : 'PG', LIB : 'Papouasie-Nouvelle-Guinée',  INDICATIF : '+675' },
    { CODE : 'PY', LIB : 'Paraguay',  INDICATIF : '+595' },
    { CODE : 'PE', LIB : 'Pérou',  INDICATIF : '+51' },
    { CODE : 'PH', LIB : 'Philippines',  INDICATIF : '+63' },
    { CODE : 'PL', LIB : 'Pologne',  INDICATIF : '+48' },
    { CODE : 'PT', LIB : 'Portugal',  INDICATIF : '+351' },
    { CODE : 'QA', LIB : 'Qatar',  INDICATIF : '+974' },
    { CODE : 'KR', LIB : 'République de Corée',  INDICATIF : '+82' },
    { CODE : 'MD', LIB : 'République de Moldova',  INDICATIF : '+373' },
    { CODE : 'RO', LIB : 'Roumanie',  INDICATIF : '+40' },
    { CODE : 'RU', LIB : 'Fédération de Russie',  INDICATIF : '+7' },
    { CODE : 'RW', LIB : 'Rwanda',  INDICATIF : '+250' },
    { CODE : 'KN', LIB : 'Saint-Kitts-et-Nevis',  INDICATIF : '+1-869' },
    { CODE : 'LC', LIB : 'Sainte-Lucie',  INDICATIF : '+1-758' },
    { CODE : 'VC', LIB : 'Saint-Vincent-et-les Grenadines',  INDICATIF : '+1-784' },
    { CODE : 'WS', LIB : 'Samoa',  INDICATIF : '+685' },
    { CODE : 'SM', LIB : 'Saint-Marin',  INDICATIF : '+378' },
    { CODE : 'ST', LIB : 'Sao Tomé-et-Principe',  INDICATIF : '+239' },
    { CODE : 'SA', LIB : 'Arabie saoudite',  INDICATIF : '+966' },
    { CODE : 'SN', LIB : 'Sénégal',  INDICATIF : '+221' },
    { CODE : 'RS', LIB : 'Serbie',  INDICATIF : '+381' },
    { CODE : 'SC', LIB : 'Seychelles',  INDICATIF : '+248' },
    { CODE : 'SL', LIB : 'Sierra Leone',  INDICATIF : '+232' },
    { CODE : 'SG', LIB : 'Singapour',  INDICATIF : '+65' },
    { CODE : 'SK', LIB : 'Slovaquie',  INDICATIF : '+421' },
    { CODE : 'SI', LIB : 'Slovénie',  INDICATIF : '+386' },
    { CODE : 'SB', LIB : 'Salomon',  INDICATIF : '+677' },
    { CODE : 'SO', LIB : 'Somalie',  INDICATIF : '+252' },
    { CODE : 'ZA', LIB : 'Afrique du Sud',  INDICATIF : '+27' },
    { CODE : 'SS', LIB : 'Soudan du Sud',  INDICATIF : '+211' },
    { CODE : 'ES', LIB : 'Espagne',  INDICATIF : '+34' },
    { CODE : 'LK', LIB : 'Sri Lanka',  INDICATIF : '+94' },
    { CODE : 'SD', LIB : 'Soudan',  INDICATIF : '+249' },
    { CODE : 'SR', LIB : 'Suriname',  INDICATIF : '+597' },
    { CODE : 'SZ', LIB : 'Eswatini',  INDICATIF : '+268' },
    { CODE : 'SE', LIB : 'Suède',  INDICATIF : '+46' },
    { CODE : 'CH', LIB : 'Suisse',  INDICATIF : '+41' },
    { CODE : 'SY', LIB : 'République arabe syrienne',  INDICATIF : '+963' },
    { CODE : 'TJ', LIB : 'Tadjikistan',  INDICATIF : '+992' },
    { CODE : 'TH', LIB : 'Thaïlande',  INDICATIF : '+66' },
    { CODE : 'MK', LIB : 'Macédoine du Nord',  INDICATIF : '+389' },
    { CODE : 'TL', LIB : 'Timor-Leste',  INDICATIF : '+670' },
    { CODE : 'TG', LIB : 'Togo',  INDICATIF : '+228' },
    { CODE : 'TO', LIB : 'Tonga',  INDICATIF : '+676' },
    { CODE : 'TT', LIB : 'Trinité-et-Tobago',  INDICATIF : '+1-868' },
    { CODE : 'TN', LIB : 'Tunisie',  INDICATIF : '+216' },
    { CODE : 'TR', LIB : 'Turquie',  INDICATIF : '+90' },
    { CODE : 'TM', LIB : 'Turkménistan',  INDICATIF : '+993' },
    { CODE : 'TV', LIB : 'Tuvalu',  INDICATIF : '+688' },
    { CODE : 'UG', LIB : 'Ouganda',  INDICATIF : '+256' },
    { CODE : 'UA', LIB : 'Ukraine',  INDICATIF : '+380' },
    { CODE : 'AE', LIB : 'Émirats arabes unis', INDICATIF : '+971' },
];